import {_Sitemap} from '@localization/siteMap/breadcrumbs/_Sitemap.ts';
import {Paper} from "@mui/material";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {Assignment, Build, Dashboard, Gavel, MonetizationOn, Pix, Shield, ShoppingCart} from "@mui/icons-material";
import {PermissionableButton} from "@shared/specialComponents/PermissionableButton.tsx";

export const HomePage = () => {
    return (
        <DefaultContainer titulo={'inicio'}
                          size={'medium'}
                          component={Paper}>
            <PermissionableButton icon={<Assignment/>}
                                  permission={["CriarSolicitacaoMembro", "AprovarSolicitacao", "CriarTipoSolicitacao", "VisualizarSolicitacoesMembro", 'VisualizarOrcamentos']}
                                  goTo={_Sitemap.solicitacoes}
                                  showEvenWithoutAccess
                                  label={'Solicitações'}/>
            <PermissionableButton permission={['VisualizarRecursoMembro']}
                                  goTo={_Sitemap.recurso}
                                  icon={<MonetizationOn/>}
                                  label={'recursos'}/>
            <PermissionableButton icon={<Gavel/>}
                                  permission={["VisualizarContratos"]}
                                  goTo={_Sitemap.contratos}
                                  label={'Contratos'}/>
            <PermissionableButton icon={<Assignment/>}
                                  permission={["VisualizarFormaPagamento"]}
                                  goTo={_Sitemap.formasPagamento}
                                  label={'Formas de Pagamento'}/>
            <PermissionableButton icon={<Pix/>}
                                  permission={["VisualizarContasContabeis"]}
                                  goTo={_Sitemap.contaContabil}
                                  label={'Contas contabeis'}/>
            <PermissionableButton icon={<ShoppingCart/>}
                                  permission={["CriarProduto", 'EditarProduto', 'VisualizarProdutos']}
                                  showEvenWithoutAccess
                                  goTo={_Sitemap.produtos}
                                  label={'Produtos'}/>
            <PermissionableButton icon={<Assignment/>}
                                  permission={["CriarFornecedor", "VisualizarFornecedores"]}
                                  showEvenWithoutAccess
                                  goTo={_Sitemap.fornecedores}
                                  label={'Fornecedores'}/>
            <PermissionableButton icon={<Shield/>}
                                  permission={["CriarUsuario", "VisualizarUsuarios"]}
                                  goTo={_Sitemap.seguranca.children.usuarios}
                                  label={'Gerenciar Segurança'}/>
            <PermissionableButton icon={<Build/>}
                                  permission={['CriarEmpresa']}
                                  goTo={_Sitemap.empresas.fullUrl}
                                  label={'Gerenciar Empresas'}/>
            <PermissionableButton permission={['NONE' as any]} label={'Dashboards'}
                                  goTo={_Sitemap.dashboard.children.solicitacoes.fullUrl}
                                  icon={<Dashboard/>}
            />
        </DefaultContainer>
    );
};